module.exports = __webpack_public_path__ + "static/media/Image 9.8878e741.jpg";